export default "__VITE_ASSET__a276a352__"